module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "FMH-1"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("[CONTENTS]")])]), _vm._v(" "), _c('p', {
    staticClass: "CFMH"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/title",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])])]), _vm._v(" "), _c('p', {
    staticClass: "CFMH"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Notice")])])]), _vm._v(" "), _c('p', {
    staticClass: "CFMH"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/foreword"
    }
  }, [_vm._v("Foreword by Ray Kurzweil")])])]), _vm._v(" "), _c('p', {
    staticClass: "CFMH"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction"
    }
  }, [_vm._v("Introduction: A Clone in the World")])])]), _vm._v(" "), _c('p', {
    staticClass: "CFMH1"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/dedication"
    }
  }, [_vm._v("Dedication")])])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('div', {
    staticClass: "td2"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "SC-B-ccn"
  }, [_vm._v("ONE:")])])]), _c('td', [_c('p', {
    staticClass: "td1"
  })]), _c('td', [_c('p', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1"
    }
  }, [_c('span', {
    staticClass: "ePub-B-ccn"
  }, [_vm._v("The Me in the Machine")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('div', {
    staticClass: "td2"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "SC-B-ccn"
  }, [_vm._v("TWO:")])])]), _c('td', [_c('p', {
    staticClass: "td1"
  })]), _c('td', [_c('p', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B-ccn"
  }, [_vm._v("Our Doppelgängers Already Exist")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('div', {
    staticClass: "td2"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "SC-B-ccn"
  }, [_vm._v("THREE:")])])]), _c('td', [_c('p', {
    staticClass: "td1"
  })]), _c('td', [_c('p', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B-ccn"
  }, [_vm._v("Mindcloning, Natural Selection, and Digital Eugenics")])]), _c('br'), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3a",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B-ccn"
  }, [_vm._v("Illustration: Since mindclones are us, they will have bad hair days too.")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('div', {
    staticClass: "td2"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "SC-B-ccn"
  }, [_vm._v("FOUR:")])])]), _c('td', [_c('p', {
    staticClass: "td1"
  })]), _c('td', [_c('p', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B-ccn"
  }, [_vm._v("Pardon Me While I Have Technical Difficulties")])]), _c('br'), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#ch4a",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B-ccn"
  }, [_vm._v("Illustration: Mindclones will have humanlike consciousness, so some will likely display humanlike freakiness, or their own unique version of freaky.")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('div', {
    staticClass: "td2"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "SC-B-ccn"
  }, [_vm._v("FIVE:")])])]), _c('td', [_c('p', {
    staticClass: "td1"
  })]), _c('td', [_c('p', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B-ccn"
  }, [_vm._v("Elbow Room")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('div', {
    staticClass: "td2"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "SC-B-ccn"
  }, [_vm._v("SIX:")])])]), _c('td', [_c('p', {
    staticClass: "td1"
  })]), _c('td', [_c('p', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B-ccn"
  }, [_vm._v("Evolution or Revolution?")])]), _c('br'), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#ch6a",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B-ccn"
  }, [_vm._v("Illustration: Social Acceptance of Weirdness")])]), _c('br'), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#ch6b",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B-ccn"
  }, [_vm._v("Illustration: The New Electorate")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('div', {
    staticClass: "td2"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "SC-B-ccn"
  }, [_vm._v("SEVEN:")])])]), _c('td', [_c('p', {
    staticClass: "td1"
  })]), _c('td', [_c('p', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B-ccn"
  }, [_vm._v("Rethinking Kinship Systems")])]), _c('br'), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7a",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B-ccn"
  }, [_vm._v("Illustration: Fleshism Strikes Back")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('div', {
    staticClass: "td2"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "SC-B-ccn"
  }, [_vm._v("EIGHT:")])])]), _c('td', [_c('p', {
    staticClass: "td1"
  })]), _c('td', [_c('p', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B-ccn"
  }, [_vm._v("Law and Liberty")])]), _c('br'), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter8#ch8a",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B-ccn"
  }, [_vm._v("Illustration: The Mindclone Plea")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('div', {
    staticClass: "td2"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "SC-B-ccn"
  }, [_vm._v("NINE:")])])]), _c('td', [_c('p', {
    staticClass: "td1"
  })]), _c('td', [_c('p', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B-ccn"
  }, [_vm._v("G-d and Mindclones")])]), _c('br'), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#ch9a",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B-ccn"
  }, [_vm._v("Illustration: Alan Turing—Enigma Code Breaker")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('div', {
    staticClass: "td2"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "SC-B-ccn"
  }, [_vm._v("TEN:")])])]), _c('td', [_c('p', {
    staticClass: "td1"
  })]), _c('td', [_c('p', {
    staticClass: "td1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B-ccn"
  }, [_vm._v("The Future of Forever")])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }), _vm._v(" "), _c('p', {
    staticClass: "CBMH"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/glossary",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glossary")])])]), _vm._v(" "), _c('p', {
    staticClass: "CBMH"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "CFMH"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/adcard",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Also by Martine Rothblatt")])])]), _vm._v(" "), _c('p', {
    staticClass: "CFMH"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/abouttheauthor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])]), _vm._v(" "), _c('p', {
    staticClass: "CBMH"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "CBMH"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Selected Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "CBMH"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "CFMH"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 66
// module chunks = 0